import React, { Component } from 'react';
import './Login.css';
import Http from '../../Http';
import { Slide, Snackbar } from '@material-ui/core';
import { AuthContext } from "../../context/authContext";
import defaultLogo from '../../exxprezo-logo.svg';

class Login extends Component {
	state = {
		user: '',
		password: '',
		showPassword: false,
		focusedField: null,
		sbOpen: false,
		sbMsg: '',
		loading: false,
	};

	toggleShowPassword = () => {
		this.setState(prevState => ({ showPassword: !prevState.showPassword }));
	};

	submit = async (e) => {
		if (e) {
			e.preventDefault();
		}
		const { user, password, loading } = this.state;
		if (loading) return;

		const cleanUser = user.replace(/\s+/g, '');
		if (!cleanUser || !password) {
			this.setState({
				sbOpen: true,
				sbMsg: 'Por favor ingrese usuario y contraseña',
			});
			return;
		}

		this.setState({ loading: true, sbMsg: '' });

		try {
			let Res = await Http.post('login', { user: cleanUser, password }, false);
			console.log({ Res });
			if (!Res.error) {
				this.context.setUser(Res.data.usuario);
				localStorage.setItem('tt', Res.data.sestoken);
				this.setState({ loading: false });
				this.props.onLogin();
				return;
			}
			this.setState({
				sbOpen: true,
				sbMsg: Res.errMsg || 'Credenciales incorrectas',
				loading: false
			});
		} catch (error) {
			this.setState({
				sbOpen: true,
				sbMsg: 'Error al conectar con el servidor',
				loading: false
			});
		}
	};

	render() {
		const { user, password, showPassword, focusedField, sbOpen, sbMsg, loading } = this.state;
		const { logo } = this.props;
		const logoSrc = logo || defaultLogo;

		return (
			<div className="exx-login-container">
				{/* Fondo Vectorial de Ondas Tonales en Variantes de Naranja (Sin degradados) */}
				<div className="exx-bg-waves" aria-hidden="true">
					<svg viewBox="0 0 1440 900" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
						<rect width="1440" height="900" fill="#f56d1c" />
						<path
							d="M-100,-100 Q150,300 450,150 T1000,0 L1440,-100 Z"
							fill="#ff7d30"
							opacity="0.85"
						/>
						<path
							d="M-50,450 C250,350 400,750 850,550 C1200,400 1350,650 1550,500 L1550,1000 L-50,1000 Z"
							fill="#db5004"
							opacity="0.8"
						/>
						<path
							d="M0,720 C350,600 650,880 1100,700 C1300,620 1400,680 1500,650 L1500,1000 L0,1000 Z"
							fill="#c94000"
							opacity="0.9"
						/>
						<path
							d="M-80,180 C180,180 320,400 320,650 C320,800 240,950 150,1050 L-80,1050 Z"
							fill="#ea5a08"
							opacity="0.45"
						/>
					</svg>
				</div>

				{/* Tarjeta Central Flotante */}
				<div className="exx-login-card">
					{/* Ondas Internas de la Tarjeta */}
					<div className="exx-card-waves" aria-hidden="true">
						<svg viewBox="0 0 780 480" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
							<rect width="780" height="480" fill="#cc4200" />
							<path
								d="M-50,150 C150,80 300,320 550,180 C680,100 750,160 820,120 L820,-50 L-50,-50 Z"
								fill="#db4f05"
								opacity="0.45"
							/>
							<path
								d="M-50,340 C200,260 400,460 700,310 C750,290 800,310 850,300 L850,520 L-50,520 Z"
								fill="#b83800"
								opacity="0.6"
							/>
							<path
								d="M520,-30 C640,80 720,240 700,400 L850,400 L850,-30 Z"
								fill="#a63200"
								opacity="0.35"
							/>
						</svg>
					</div>

					{/* Contenido Central */}
					<div className="exx-card-content">
						{/* Logotipo en sus colores originales */}
						<div className="exx-logo-container">
							<img src={logoSrc} alt="Logo" className="exx-logo-img" />
						</div>

						{/* Formulario */}
						<form className="exx-form" onSubmit={this.submit}>
							{/* Campo Usuario */}
							<div className={`exx-input-wrapper ${focusedField === 'user' ? 'focused' : ''}`}>
								<div className="exx-input-icon">
									<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
										<circle cx="12" cy="7" r="4" />
									</svg>
								</div>
								<input
									type="text"
									className="exx-input"
									placeholder="USUARIO"
									autoComplete="username"
									value={user}
									onChange={(e) => this.setState({ user: e.target.value })}
									onFocus={() => this.setState({ focusedField: 'user' })}
									onBlur={() => this.setState({ focusedField: null })}
									disabled={loading}
									autoFocus
								/>
							</div>

							{/* Campo Contraseña */}
							<div className={`exx-input-wrapper ${focusedField === 'password' ? 'focused' : ''}`}>
								<div className="exx-input-icon">
									<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
										<path d="M7 11V7a5 5 0 0 1 10 0v4" />
									</svg>
								</div>
								<input
									type={showPassword ? 'text' : 'password'}
									className="exx-input"
									placeholder="CONTRASEÑA"
									autoComplete="current-password"
									value={password}
									onChange={(e) => this.setState({ password: e.target.value })}
									onFocus={() => this.setState({ focusedField: 'password' })}
									onBlur={() => this.setState({ focusedField: null })}
									disabled={loading}
								/>
								<button
									type="button"
									className="exx-eye-btn"
									onClick={this.toggleShowPassword}
									tabIndex={-1}
									aria-label={showPassword ? 'Ocultar' : 'Mostrar'}
								>
									{showPassword ? (
										<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
											<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
											<line x1="1" y1="1" x2="23" y2="23" />
										</svg>
									) : (
										<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
											<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
											<circle cx="12" cy="12" r="3" />
										</svg>
									)}
								</button>
							</div>

							{/* Botón Sólido Blanco */}
							<button
								type="submit"
								className="exx-btn-submit"
								disabled={loading}
							>
								{loading ? (
									<div className="exx-spinner" />
								) : (
									<span>INGRESAR</span>
								)}
							</button>
						</form>

						{/* Enlace Inferior Discreto */}
						<div className="exx-bottom-link">
							Exxprezo Soluciones Logísticas
						</div>
					</div>
				</div>

				{/* Notificaciones */}
				<Snackbar
					open={sbOpen}
					autoHideDuration={4000}
					onClose={() => { this.setState({ sbOpen: false }); }}
					TransitionComponent={Slide}
					ContentProps={{
						'aria-describedby': 'login-sb-msg',
						style: {
							backgroundColor: '#ffffff',
							color: '#c94000',
							fontWeight: 600,
							borderRadius: '8px',
							boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
						}
					}}
					message={<span id="login-sb-msg">{sbMsg}</span>}
				/>
			</div>
		);
	}
}

Login.contextType = AuthContext;
export default Login;
